$(() => {
    const showResults = 10;
    const totalResults = $('body.search-results #content ul li').length;
    if (totalResults > showResults) {
        $('body.search-results #content .view-more').css('display', 'block');
        $('body').addClass('more-result');
    } else {
        $('body.search-results #content .view-more').css('display', 'none');
        $('body').removeClass('more-result');
    }

    $('body.search-results #content .view-more').on('click', () => {
        $('body.search-results #content .view-more').css('display', 'none');
        $('body').removeClass('more-result');
    });
});